<template>
  <b-modal
    :active.sync="show"
    trap-focus
    aria-role="dialog"
    scroll="keep"
    :width="1000"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form @submit.prevent="passes(save)">
        <div class="modal-card" style="width: 1000px; height: 600px">
          <header class="modal-card-head">
            <p class="modal-card-title">Copy Sequence</p>
          </header>
          <section class="modal-card-body">
            <BaseDateTimePicker label="New Start Date" v-model="startdate" />
          </section>
          <footer class="modal-card-foot" style="display: block">
            <button class="button" type="button" @click="closeModal">
              Cancel
            </button>
            <button class="button is-primary" type="button" @click="save">
              Copy
            </button>
          </footer>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import ScheduleApi from '@/api/schedules'
import { sortBy } from 'lodash'
import BaseDateTimePicker from '@/components/BaseDateTimePicker'

export default {
  name: 'CopySequenceModal',
  components: {
    BaseDateTimePicker,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    repeatsId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      initialized: false,
      showModal: this.show,
      startdate: new Date(),
    }
  },

  async created() {
    this.initialized = true
  },
  methods: {
    async save() {
      await ScheduleApi.copySequence({
        repeats_id: this.repeatsId,
        start_time: new Date(this.startdate),
      })
      this.$buefy.toast.open({
        message: 'Sequence copied successfully!',
        position: 'is-top',
        type: 'is-success',
      })
      this.closeModal()
      this.$emit('refresh')
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },
  },
}
</script>
